// Copyright (c) Ensho Health, 2021 to present

import styled from 'styled-components';
import { InputGroup, Button, Colors } from '@blueprintjs/core';
import { ENSHO_COLORS } from '../../constants';

export const StyledEnshoButton = styled(Button)`
  margin-top: 20px;
  background-color: ${ENSHO_COLORS.GREEN.BUTTON};
  padding: 0;
  color: ${Colors.BLACK};
  font-size: 10pt;
  height: 40px;
  border-radius: 3px;
  width: 90%;
  font-family: sohne;
`;

export const StyledSubmitButton = styled(Button)`
  margin-top: 20px;
  width: 100%;
  height: 40px;
  color: ${Colors.WHITE};
  background-color: ${Colors.BLACK};
  &:disabled {
    background-color: ${ENSHO_COLORS.GRAY.DISABLED};
  }
`;

export const StyledTitle = styled.div`
  padding-bottom: 30px;
  padding-top: 30px;
  font-size: 36px;
  font-weight: 400;
  text-align: center;
  border-bottom: 1px solid black;
`;

export const StyledError = styled.p`
  color: ${ENSHO_COLORS.RED.ERROR};
  margin-top: 30px;
  text-align: left;
`;

export const StyledInput = styled(InputGroup)``;

export const StyledInputGroup = styled.div`
  width: 90%;
  margin: 0px auto;
`;

export const StyledImage = styled.img`
  margin-bottom: 10px;
`;

export const StyledForm = styled.form`
  text-align: center;
  width: ${(props) => (props.isMobile ? '95%' : '440px')};
  margin-top: ${(props) => props.isMobile && '1px'};
  height: ${(props) => props.isMobile && '100%'};
  padding-bottom: 30px;
`;

export const StyledInfo = styled.p`
  margin-top: 20px;
  padding-left: 2px;
  text-align: left;
  font-size: 12px;
  font-family: sohne;
`;
